
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersNightColour as ObiLightSnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-night-colour.js';
 
 
 

 
 export const ObiLightSnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-night-colour',
   elementClass: ObiLightSnowShowersNightColourElement,
   events: {
     
   }
  });
 
 